import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Initialiser les animations GSAP
const initRevealAnimations = () => {
    try {
        gsap.registerPlugin(ScrollTrigger);

        gsap.utils.toArray('.with-reveal').forEach((withReveal) => {
            const revealedSections = withReveal.querySelectorAll('.to-reveal');

            if (revealedSections.length > 0) {
                gsap.to(revealedSections, {
                    duration: .5,
                    stagger: 0.6,
                    opacity: 1,
                    scale: 1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: withReveal,
                        start: () => `top bottom-=${window.innerHeight * .35}`,
                        invalidateOnRefresh: true
                    }
                });
            }
        });
    } catch (error) {
        console.error('Erreur lors de l\'initialisation des animations:', error);
    }
};

// Attendre que le DOM soit prêt
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRevealAnimations);
} else {
    initRevealAnimations();
}
